import styled from 'styled-components';

export const InfoIcon = styled.img`
  height: 12px;
  width: 12px;
  cursor: pointer;
`;
